module.exports = __webpack_public_path__ + "static/media/traning logo.1a7d3d87.png";